import React from "react";
import {useTranslation} from "react-i18next";
import {StyledChecklistDropdown} from "./ChecklistDropdown.styled";
import {Scrollbar} from "react-scrollbars-custom";
import Checkbox from "../simple/Checkbox";
import {useSelector} from "react-redux";


/**
 * @param {object[]} options
 * @param {string} labelField an option field name which contains label to display in ui
 * @param value
 * @param setValueHandler
 * */
export function ChecklistDropdown({options, labelField, value, setValueHandler}) {
    const {t} = useTranslation();
    const ltr = useSelector((state) => state.common.ltrEnabled);

    function handleCheckboxChecked(option) {
        const wasFound = value.find(v => v === option);
        if (wasFound == null) {
            setValueHandler([...value, option]);
        } else {
            setValueHandler([...value.filter(v => v !== option)]);
        }
    }

    function handleSelectAllChanged() {
        if (value.length > 0) {
            setValueHandler([]);
        } else {
            setValueHandler([...options]);
        }
    }

    return (
        <StyledChecklistDropdown>
            <Scrollbar
                style={{ width: '100%', height: 'calc(100rm - 200px)' }}
                trackYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div {...restProps} ref={elementRef} className="scroll-track" />;
                    }
                }}
                thumbYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div {...restProps} ref={elementRef} className="scroll-thumb" />;
                    }
                }}
                ltr={ltr}
                noScrollX={true}
            >
                <>
            <div className={'list-row'} onClick={()=>handleSelectAllChanged()}>
                <Checkbox
                    labelFontWeight = {'normal'}
                    className = {'checklist-dropbox'}
                    label={t('messagePlatform.labels.selectAll')}
                    checked={options.length === value.length}
                    onChange={()=>handleSelectAllChanged()}
                    borderRadius={3}
                    size={20}
                />
            </div>
            <div className={'all-rows'}>
                {options.map(option=>{
                    const checked = value.indexOf(option) > -1;
                    return (<div  onClick={() => handleCheckboxChecked(option)} className={checked ? 'list-row-checked' : 'list-row'}><Checkbox className={'checklist-dropbox'} borderRadius={3}
                                                           size={20} labelFontWeight={'normal'} label={option[labelField]}
                                                           checked = {checked}
                                                           onChange={() => handleCheckboxChecked(option)}/></div>)}
            )}
            </div>
                </>
            </Scrollbar>
        </StyledChecklistDropdown>
    )
}
